export default __webpack_public_path__ + "static/media/fault.6196932f.svg";